import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="m14 7-5 5 5 5z" /></g>,<defs key="1"></defs>,]
, 'ControlsDropDownLeftx');
